import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, LoadingController, ViewController } from 'ionic-angular';

import { IlsProvider } from '../../providers/ils/ils';
import moment from 'moment';
import { PatronProvider } from '../../providers/patron/patron';
import { CoPopoverKeyboardComponent } from '../../components/co-popover-keyboard/co-popover-keyboard';
import { ConfigProvider } from '../../providers/config/config';
import { CoCheckoutConfirmPage } from '../co-checkout-confirm/co-checkout-confirm';
import { NovelistProvider } from '../../providers/novelist/novelist';
import { AppState } from '../../config/state';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
/**
 * Generated class for the RenewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-renew',
  templateUrl: 'renew.html',
})
export class RenewPage {
  scanInfo: any;
  patron: any;
  patronLoggedIn: boolean = false;
  returnDate: string = moment().add(1, 'month').format("YYYY-MM-DD HH:mm:ss");
  newReturnDate: string = moment().add(6, 'weeks').format("YYYY-MM-DD HH:mm:ss");
  renewList = {};
  isForApp: boolean;
  showBookList: boolean = false;
  bookList: any = [];
  renewedBookList: any = [];
  isbnObj: any = {};
  menuSide: string = "left";

  constructor(public navCtrl: NavController, public navParams: NavParams, public toast : ToastAlertsProvider, public popoverCtrl: PopoverController, public ilsProdiver: IlsProvider, public patronProvider: PatronProvider, public config: ConfigProvider, public loading:LoadingController, public novelist:NovelistProvider, private state: AppState, private viewCtrl : ViewController) {
    this.isForApp = this.state.cordovaAvailable;

    this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";
  }

  // ionViewDidLoad() {
  //   if ( !this.bookList || this.bookList.length <= 0) {
  //     this.createLibraryCardScannerPopover();
  //   }
  // }

  // async getCheckedOutItems(patron){
  //   const res = await this.patronProvider.getCheckouts(patron);
  //   // console.log(res);
  //   this.bookList = res;
  //   this.bookList.forEach((book, i) => {
  //     this.renewList[i] = false;
  //   });
  //   res.forEach(book => {
  //     let bookIsbn = book.bib.isbns[0].split(' ')[0]
  //     if (bookIsbn.length === 10 || bookIsbn.length === 13){
  //       this.isbnObj[book.bib.id] = {number: bookIsbn, type: 'isbn'};
  //     } else {
  //       this.isbnObj[book.bib.id] = {number: bookIsbn, type: 'upc'}
  //     }
  //   });
  //   // console.log(this.isbnObj);
  //   this.showBookList = true;
  //   return true;
  // }

  // scanAnotherBook(){
  //   this.createLibraryCardScannerPopover();
  // }

  // getBookInformation(info){
  //   this.ilsProdiver.getBibDetailsFromId(info).then((res)=>{
  //     res.barcode = info
  //     this.bookList.push(res);
  //     // console.log('book info', res)
  //   });
  // }

  // triggerToast(msg) {
  //   this.toast.triggerToast(msg, '');
  // }

  // goToNext(){
  //   this.bookList.forEach((book, i) => {
  //     if (this.renewList[i]){
  //       this.renewedBookList.push(book);
  //     }
  //   });
  //   // console.log(this.bookList[0].bib.isbns[0])
  //   if (this.renewedBookList.length > 0){
  //     this.config.load(this.state.appId).then(cfg => {
  //       this.navCtrl.push(CoCheckoutConfirmPage, { page: 'renew', books: this.renewedBookList });
  //     });
  //   } else {
  //     this.triggerToast('Please select an item to renew')
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/pages/renew/renew.ts